<template>
  <div class="customer-phone-number-verify-dialog-container" v-if="show">

    <loading :loading="loading"></loading>

    <error-alert-item
        :error-alert-event="errorAlertEvent"
        :network-error="networkError"
        @resetErrorAlertEvent="errorAlertEvent=false"
    ></error-alert-item>

    <wxc-overlay :left='left' :show="true" :hasAnimation="false"></wxc-overlay>
    <div class="dialog-box z-index" :style="{top:top+'px', left: left+'px', right: right + 'px'}">
      <div class="dialog-content-without-cross">

        <weex-text class="item-heading">Reset Password</weex-text>
        <weex-text class="text-align-center text-color-gray">Your password is expired, Please
          reset.
        </weex-text>

        <div class="input_container">
          <weex-text class="input_label">
            New Password <span class="text-color-red margin-left-5"> * </span>
          </weex-text>
          <div class="item-phone-number-input-container margin-top-5">
            <input
                class="item-phone-number-input"
                v-model="password"
                type="password"
                required
            />
          </div>
          <field-error-item
            :show-error="showFieldError('password')"
            :error-msg="getErrorMsg()"
          ></field-error-item>
        </div>

        <div class="input_container">
          <weex-text class="input_label">
            Repeat Password <span class="text-color-red margin-left-5"> * </span>
          </weex-text>
          <div class="item-phone-number-input-container margin-top-5">
            <input
                class="item-phone-number-input"
                v-model="confirmPassword"
                type="password"
                required
            />
          </div>
          <field-error-item
            :show-error="showFieldError('confirm_password')"
            :error-msg="getErrorMsg()"
          ></field-error-item>
        </div>

        <div class="item-row-alignment margin_top_40">
          <wxc-button
              text="Next"
              class="horizontal_center margin-top-30"
              size="small"
              type="blue"
              @wxcButtonClicked="updatePassword"
          ></wxc-button>

          <wxc-button
              text="Dismiss"
              class="horizontal_center margin-top-30"
              type="red"
              size="small"
              @wxcButtonClicked="onDismissClicked"
          ></wxc-button>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import WxcOverlay from "../../../weex-ui/packages/wxc-overlay/index";
import AlertService from "../core/alert/AlertService";
import {MessageConstants} from "../../utils/MessageConstantUtil";
import DataSource from "../../data/DataSource";
import Loading from "../layout/Loading";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import EzUtils from '../../utils/EzUtils';
import { ValidationPatterns } from '../../utils/ValidationPatterns';
import FieldErrorItem from "../layout/FieldErrorItem";

export default {
  components: {
    WxcOverlay,
    WxcButton,
    Loading,
    ErrorAlertItem,
    FieldErrorItem
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true
    },
    userId: {
      type: Number,
      default: -1,
      required: true
    },
    top: {
      type: Number,
      default: 20
    },
    left: {
      type: Number,
      default: 0
    },
    right: {
      type: Number,
      default: 0
    }
  },

  data: () => ({
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    password: "",
    confirmPassword: "",
  }),

  methods: {
    showToast(message) {
      AlertService.showToast(message);
    },

    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    updatePassword() {
      if (this.checkValidation()) {
        this.loading = true;
        DataSource.updatePassword(this.userId, this.password, this.confirmPassword)
        .then(updatePasswordRes => {
          this.loading = false;
          if (updatePasswordRes.errorOccurred) {
            this.showError(updatePasswordRes.data);
          } else {
            const updatePasswordData = updatePasswordRes.data;
            if (updatePasswordData
                && updatePasswordData.changes
                && updatePasswordData.changes.passwordEncoded
            ) {
              this.onPasswordUpdated();
            } else {
              this.password = "";
              this.confirmPassword = "";
              this.showError({title: "New password should be different than old password."});
            }
          }
        })
      }
    },

    onDismissClicked() {
      this.$emit("dismissClicked", {});
    },

    checkValidation() {
      if (!this.password || !this.confirmPassword) {
        AlertService.showToast(MessageConstants.INVALID_PASSWORD);
        return false;
      }
      if (this.password !== this.confirmPassword) {
        AlertService.showToast(MessageConstants.SAME_PASSWORD);
        return false;
      }
      return true;
    },

    onPasswordUpdated() {
      this.$emit("onPasswordUpdated", {userName: this.userName, password: this.password});
    },

    showFieldError(passwordType) {
      let password = passwordType == "password" ? this.password : this.confirmPassword;
      return password ? !EzUtils.doesPatternMatch(ValidationPatterns.PASSWORD_PATTERN, password) : false;
    },

    getErrorMsg() {
      return MessageConstants.INVALID_PASSWORD;
    },
  },

};
</script>

<style scoped src="../../assets/style/base.css"></style>

<style scoped>

.z-index {
  z-index: 10;
}

</style>

